export default function Home() {
  return (
    <>
      <main className="flex justify-center flex-col items-center space-y-4">
        <section className="text-center text-3xl py-20">Hello Moto</section>
        <a
          href="/signup"
          className="bg-yellow-500 w-20 p-2 border-2 border-black"
        >
          Register
        </a>
        <a
          href="/profile"
          className="bg-yellow-500 w-20 p-2 border-2 border-black"
        >
          Profile
        </a>
      </main>
    </>
  );
}
